import React from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';

const EditModal = ({
  visible = false,
  originalTitle = '',
  changedTitle = '',
  onClose,
  onSubmit,
}) => {
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      originalTitle,
      changedTitle,
    },
    validationSchema: Yup.object({
      originalTitle: Yup.string().required('Privalomas laukas'),
      changedTitle: Yup.string().required('Privalomas laukas'),
    }),
    onSubmit: (values) => {
      onSubmit(values);
      onClose();
    },
  });

  if (!visible) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <button style={styles.closeButton} onClick={onClose}>
          &times;
        </button>
        <form onSubmit={formik.handleSubmit} style={styles.content}>
          <label style={styles.label}>Originalus pavadinimas</label>
          <input
            name="originalTitle"
            type="text"
            value={formik.values.originalTitle}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            style={styles.input}
          />
          {formik.touched.originalTitle && formik.errors.originalTitle && (
            <div style={styles.error}>{formik.errors.originalTitle}</div>
          )}

          <label style={styles.label}>Pakeistas pavadinimas</label>

          <input
            name="changedTitle"
            type="text"
            value={formik.values.changedTitle}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            style={styles.input}
          />
          {formik.touched.changedTitle && formik.errors.changedTitle && (
            <div style={styles.error}>{formik.errors.changedTitle}</div>
          )}

          <button type="submit" style={styles.saveButton}>
            Išsaugoti
          </button>
        </form>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modal: {
    backgroundColor: '#fff',
    borderRadius: '16px',
    padding: '20px',
    position: 'relative',
    width: '360px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
  },
  closeButton: {
    position: 'absolute',
    top: 10,
    right: 10,
    fontSize: '20px',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  label: {
    fontWeight: 'bold',
    marginTop: '10px',
  },
  input: {
    padding: '8px',
    borderRadius: '8px',
    border: '1px solid #ccc',
    outline: 'none',
  },
  textarea: {
    padding: '8px',
    borderRadius: '8px',
    border: '1px solid #3b82f6',
    outline: 'none',
    minHeight: '60px',
    resize: 'none',
  },
  saveButton: {
    marginTop: '20px',
    padding: '10px',
    borderRadius: '8px',
    border: 'none',
    backgroundColor: '#3b82f6',
    color: '#fff',
    fontWeight: 'bold',
    cursor: 'pointer',
  },
  error: {
    color: 'red',
    fontSize: '12px',
  },
};

export default EditModal;
